import React from "react";
import "./contact.scss";

const EMAIL = "qwe5272184@gmail.com";
const LINKEDIN_URL = "https://www.linkedin.com/in/leheng-weng-cs";

export default function Contact() {
  return (
    <div className="contact" id="contact">
      <div className="contact__inner">
        <p className="contact__eyebrow">Contact</p>
        <h2 className="contact__title">Let&apos;s work together</h2>
        <p className="contact__subtitle">
          I&apos;m open to opportunities and happy to connect. Feel free to reach
          out by email or on LinkedIn.
        </p>
        <div className="contact__actions">
          <a
            href={`mailto:${EMAIL}`}
            className="contact__button contact__button--primary"
          >
            Email me
          </a>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="contact__button contact__button--secondary"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </div>
  );
}
